import RestrictionsDecorate from '../../../../facade/restrictions/decorate';

module.exports = RestrictionsDecorate(
  {
    haveOptions: (selection) => {
      const getRestrictions = (...args) => INKIVE.RestrictionsFacade.getElementRestrictions(selection.id, ...args);
      const globalPermissions = INKIVE.RestrictionsFacade.getAllDefaultPermissions();
      const permissionName = 'video_replace';
      const basicRestrictions = getRestrictions('basic');

      if (
        !basicRestrictions[0] ||
        typeof basicRestrictions[0][permissionName] === 'undefined'
      ) {
        basicRestrictions[0] = INKIVE.RestrictionsFacade.getAllDefaultPermissions();
      }

      return basicRestrictions[0][permissionName];
    }
  },
  { haveOptions: () => false }
);
